import mutationTypes from './helpers/mutationTypes';

const createModuleView = (storeName, api = {}, options = {}, overrides = {}) => {
    const customListFormatter =
        options && options.customListFormatter ? options.customListFormatter : false;
    const customListFetchFn =
        options && options.customListFetchFn ? options.customListFetchFn : false;

    const module = {
        name: storeName,
        namespaced: true,
        state: {
            list: [],
            selected: [],
            loading: false,
        },
        mutations: {
            [mutationTypes.SET_LIST]: (state, list) => {
                state.list = list.map((item) =>
                    customListFormatter ? customListFormatter(item) : item
                );
            },
            [mutationTypes.SET_SELECTED]: (state, selected) => {
                state.selected = selected;
            },
            [mutationTypes.SET_LOADING]: (state, loading) => {
                state.loading = loading;
            },
        },
        actions: {
            getList: async ({ commit }, options = {}) => {
                commit(mutationTypes.SET_LOADING, true);
                const fetchFn = customListFetchFn ? customListFetchFn : api[storeName].get;
                const response = await fetchFn(options);

                if (response.success) {
                    commit(mutationTypes.SET_LIST, response.data.list);
                } else {
                    commit(mutationTypes.SET_LIST, []);
                }

                commit(mutationTypes.SET_LOADING, false);
            },
            setSelected: ({ commit }, selected) => {
                commit(mutationTypes.SET_SELECTED, selected);
            },
            resetState: ({ commit }) => {
                commit(mutationTypes.SET_LIST, []);
                commit(mutationTypes.SET_SELECTED, []);
            },
        },
    };

    !overrides.modules || (module.modules = overrides.modules);

    return module;
};

export default {
    mutationTypes,
    createModuleView,
};
